import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  name: z.string(),
})

export type RenameUserFormValues = z.infer<typeof schema>

export const RENAME_USER_FORM_ID = 'RENAME_USER_FORM'
export const renameUserFormResolver = zodResolver(schema)
